import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@material-ui/core/styles'

import { useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'

import { ROUTER, DRAWER_KEYS } from '../../class/constants'
import { acLogout } from '../../class/actions'

import {
  Collapse,
  ListItem, ListItemIcon, ListItemText, withStyles
} from '@material-ui/core'
import { ExpandLess, ExpandMore } from '@material-ui/icons'
import { useState } from 'react'

function DrawerSection({ classes, id, tStr, Icon, style, selectedKey, subSections }) {
  const { t } = useTranslation()
  const theme = useTheme()
  const dispatch = useDispatch()

  const [collapseOpen, setCollapseOpen] = useState(true)

  const _getColor = id => id === selectedKey ? theme.palette.primary.main : theme.palette.textColor.main

  let textStyle = { color: _getColor(id), ...style }
  let iconStyle = { color: _getColor(id) }

  return (
    <>
      <Link
        style={{ textDecoration: 'none' }}
        to={id === DRAWER_KEYS.EXIT ? () => null : ROUTER[id]}
        onClick={id === DRAWER_KEYS.EXIT ? () => dispatch(acLogout()) : null}
      >
        <ListItem button style={textStyle} >
          <ListItemIcon><Icon style={iconStyle} /></ListItemIcon>
          <ListItemText primary={t(`drawer.${tStr}`)} />
          {subSections && (collapseOpen ? <ExpandLess onClick={() => setCollapseOpen(false)} /> : <ExpandMore onClick={() => setCollapseOpen(true)} />)}
        </ListItem>
      </Link>
      {
        subSections && (
          <Collapse in={collapseOpen} timeout="auto" unmountOnExit className={classes.collapse}>
            {
              subSections.map((m, idx) => (
                <DrawerSection
                  key={idx}
                  selectedKey={selectedKey}
                  {...m}
                />
              ))
            }
          </Collapse>
        )
      }
    </>
  )
}

DrawerSection.propTypes = {
  id: PropTypes.string.isRequired,
  tStr: PropTypes.string.isRequired,
  Icon: PropTypes.any.isRequired,
  style: PropTypes.object,
  onClick: PropTypes.func,
}

DrawerSection.defaultProps = {
  style: {},
  onClick: () => true
}

const styles = theme => ({
  collapse: {
    background: 'rgba(0, 0, 0, 0.02)',
    boxShadow: 'inset 0 0 3px rgb(0, 0, 0, 0.2)'
  }
})

export default withStyles(styles)(DrawerSection)